var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "consent-form" }, [
      _vm._m(0),
      _c("form", [
        _c("div", { staticClass: "info-wrap" }, [
          _c("div", { staticClass: "field-wrap" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "select-version" } }, [
                _vm._v(_vm._s(_vm.i18n("Template.Version"))),
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.latestVersion,
                      expression: "latestVersion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "select-version" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.latestVersion = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.getPersonalStatementInfo,
                    ],
                  },
                },
                _vm._l(_vm.versionHistory, function (item) {
                  return _c(
                    "option",
                    { key: item.Guid, domProps: { value: item.Guid } },
                    [_vm._v(" " + _vm._s(item.Version) + " ")]
                  )
                }),
                0
              ),
            ]),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ errors }) {
                        return [
                          _c("label", { attrs: { for: "input-title" } }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v(" 標題 "),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.title,
                                expression: "title",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "input-title",
                              maxlength: "50",
                            },
                            domProps: { value: _vm.title },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.title = $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          errors[0]
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(" " + _vm._s(errors[0]) + " "),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("ValidationProvider", {
                  attrs: {
                    name: _vm.i18n("Template.Content"),
                    rules: "required",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ errors }) {
                        return [
                          _c("label", { attrs: { for: "" } }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Template.Content")) + " "
                            ),
                          ]),
                          _c("VueEditor", {
                            staticStyle: { background: "rgb(255, 255, 255)" },
                            model: {
                              value: _vm.content,
                              callback: function ($$v) {
                                _vm.content = $$v
                              },
                              expression: "content",
                            },
                          }),
                          errors[0]
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(" " + _vm._s(errors[0]) + " "),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "button-wrap center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              staticStyle: { "margin-right": "5px" },
              attrs: { type: "button" },
              on: { click: _vm.createPersonalStatement },
            },
            [_vm._v(" " + _vm._s(_vm.i18n("Buttons.CreateNewVersion")) + " ")]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "button" },
              on: { click: _vm.updatePersonalStatement },
            },
            [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "note-wrap" }, [
      _c("div", { staticClass: "letter-title" }, [_vm._v("個資同意書")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }